"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const icons_1 = require("../../../../assets/icons");
const images_1 = require("../../../../assets/images");
const components_1 = require("../../../../components");
const CustomText_1 = __importDefault(require("../../../../components/text/CustomText"));
const constants_1 = require("../../../../constants");
const User_1 = __importDefault(require("../../../../networking/apis/User"));
const helpler_1 = require("../../../../utils/helpler");
const scale_1 = require("../../../../utils/scale");
const InputSearch = ({ containerStyle, ...props }) => {
    const [isFocused, setIsFocused] = (0, react_1.useState)(false);
    const handleFocus = () => setIsFocused(true);
    const handleBlur = () => setIsFocused(false);
    return (react_1.default.createElement(react_native_1.View, { style: [styles.searchInput, isFocused && { borderColor: '#00AEEF' }, containerStyle] },
        react_1.default.createElement(icons_1.IC_SEARCH, null),
        react_1.default.createElement(react_native_1.TextInput, { style: [styles.textInput], placeholder: "\u30E6\u30FC\u30B6\u30FC\u691C\u7D22", placeholderTextColor: "#C8C8C8", onFocus: handleFocus, onBlur: handleBlur, ...props })));
};
const ModalPickInheritUser = (props) => {
    const insets = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const { isVisible, onClose, onSelected } = props;
    const [users, setUsers] = (0, react_1.useState)([]);
    const [selected, setSelected] = (0, react_1.useState)();
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const refCurrentPage = (0, react_1.useRef)(1);
    const refSearchText = (0, react_1.useRef)("");
    const refIsNoMore = (0, react_1.useRef)(false);
    const refTimeout = (0, react_1.useRef)();
    const refFlatList = (0, react_1.createRef)();
    (0, react_1.useEffect)(() => {
        if (!isVisible) {
            setUsers([]);
        }
    }, [isVisible]);
    const handleSearchUser = (text) => {
        clearTimeout(refTimeout.current);
        refSearchText.current = text;
        refCurrentPage.current = 1;
        refIsNoMore.current = false;
        if (!refSearchText.current) {
            setUsers([]);
            setLoading(false);
            return;
        }
        refTimeout.current = setTimeout(() => {
            loadUsers(text, 1, false);
        }, 400);
    };
    const loadUsers = (text, page, isConcat) => {
        setLoading(true);
        User_1.default.searchUser(encodeURIComponent(text), page)
            .then((response) => {
            refCurrentPage.current = refCurrentPage.current + 1;
            if (refCurrentPage.current > response.data.last_page) {
                refIsNoMore.current = true;
            }
            isConcat ?
                setUsers([...users, ...response.data.data])
                :
                    setUsers(response.data.data);
        })
            .catch((_) => { })
            .finally(() => {
            setLoading(false);
            clearTimeout(refTimeout.current);
        });
    };
    return (react_1.default.createElement(react_native_1.Modal, { statusBarTranslucent: true, visible: isVisible, animationType: "fade", transparent: true, onRequestClose: onClose, onShow: () => {
            helpler_1.isWeb && document.body.classList.add("prevent-slice-modal");
        }, onDismiss: () => {
            helpler_1.isWeb && document.body.classList.remove("prevent-slice-modal");
        } },
        react_1.default.createElement(react_native_1.View, { style: styles.container },
            react_1.default.createElement(react_native_1.Pressable, { style: { flexGrow: 1 }, onPress: onClose }),
            react_1.default.createElement(react_native_1.View, { style: [styles.box, { paddingBottom: insets.bottom }] },
                react_1.default.createElement(react_native_1.View, { style: styles.header },
                    react_1.default.createElement(CustomText_1.default, { numberOfLines: 1, style: styles.headerBtn, onPress: onClose }, "\u30AD\u30E3\u30F3\u30BB\u30EB"),
                    react_1.default.createElement(CustomText_1.default, { weight: "600", numberOfLines: 1, style: styles.headerTitle }, "\u7D99\u627F\u5143\u306E\u5148\u8F29"),
                    react_1.default.createElement(CustomText_1.default, { numberOfLines: 1, style: [styles.headerBtn, { textAlign: 'right' }], onPress: () => onSelected(selected) }, "\u5B8C\u4E86")),
                react_1.default.createElement(react_native_1.View, { style: styles.body },
                    react_1.default.createElement(CustomText_1.default, { style: styles.text1 }, "\u9078\u629E\u4E2D\u306E\u30E6\u30FC\u30B6\u30FC"),
                    react_1.default.createElement(react_native_1.View, { style: styles.selection }, selected ?
                        react_1.default.createElement(react_native_1.View, { style: styles.selectedUser },
                            react_1.default.createElement(react_native_1.Image, { style: styles.userAvatar, source: selected.thumbnail_url ? { uri: selected.thumbnail_url } : images_1.images.AvatarDefaul }),
                            react_1.default.createElement(react_native_1.View, { style: [styles.userInfo, { marginRight: (0, scale_1.scale)(12) }] },
                                react_1.default.createElement(CustomText_1.default, { numberOfLines: 1, weight: "600", style: styles.userNickname }, selected.nickname || constants_1.DEFAULT_NAME),
                                react_1.default.createElement(CustomText_1.default, { numberOfLines: 1, style: styles.userHandle },
                                    "@",
                                    selected.user_handle)),
                            react_1.default.createElement(react_native_1.Pressable, { style: styles.unselectedBtn, onPress: () => setSelected(undefined) },
                                react_1.default.createElement(CustomText_1.default, { style: styles.unselectedLabel }, "\u524A\u9664")))
                        :
                            react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles.selectionBlank }, "\u6307\u5B9A\u306A\u3057")),
                    react_1.default.createElement(InputSearch, { onChangeText: handleSearchUser }),
                    react_1.default.createElement(react_native_1.FlatList, { ref: refFlatList, data: users, style: styles.listUser, keyExtractor: (_, index) => `${index}`, renderItem: ({ item }) => (react_1.default.createElement(react_native_1.Pressable, { style: styles.userItem, onPress: () => setSelected(item) },
                            react_1.default.createElement(react_native_1.Image, { style: styles.userAvatar, source: item.thumbnail_url ? { uri: item.thumbnail_url } : images_1.images.AvatarDefaul }),
                            react_1.default.createElement(react_native_1.View, { style: styles.userInfo },
                                react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles.userNickname, numberOfLines: 1 }, item.nickname || constants_1.DEFAULT_NAME),
                                react_1.default.createElement(CustomText_1.default, { style: styles.userHandle, numberOfLines: 1 },
                                    "@",
                                    item.user_handle)))), onScroll: ({ nativeEvent }) => {
                            if ((0, helpler_1.isCloseToBottom)(nativeEvent)) {
                                if (refIsNoMore.current || isLoading)
                                    return;
                                loadUsers(refSearchText.current, refCurrentPage.current, true);
                            }
                        }, scrollEventThrottle: 400, ListFooterComponent: () => (isLoading ?
                            react_1.default.createElement(components_1.LoadingView, { style: styles.loading })
                            :
                                null) }))))));
};
const styles = react_native_1.StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'flex-end',
        alignItems: 'center',
        backgroundColor: '#000000B2'
    },
    box: {
        width: scale_1.width,
        height: '70%',
        backgroundColor: '#FEFEFE',
        borderTopLeftRadius: (0, scale_1.scale)(16),
        borderTopRightRadius: (0, scale_1.scale)(16),
    },
    header: {
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        padding: (0, scale_1.scale)(16),
        borderBottomWidth: (0, scale_1.scale)(1),
        borderBottomColor: '#DDDDDD',
    },
    headerBtn: {
        flex: 1,
        fontSize: (0, scale_1.moderateScale)(15),
        lineHeight: (0, scale_1.moderateScale)(22.5),
        color: '#007AFF'
    },
    headerTitle: {
        flex: 1,
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#292A33',
        textAlign: 'center',
    },
    body: {
        flex: 1,
        padding: (0, scale_1.scale)(16),
    },
    text1: {
        fontSize: (0, scale_1.moderateScale)(15),
        lineHeight: (0, scale_1.moderateScale)(22.5),
        color: '#292A33',
    },
    selection: {
        width: '100%',
        height: (0, scale_1.scale)(42),
        marginTop: (0, scale_1.scale)(12),
    },
    selectedUser: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center'
    },
    unselectedBtn: {
        borderWidth: (0, scale_1.scale)(1),
        borderColor: '#D32F2F',
        borderRadius: (0, scale_1.scale)(4),
        paddingHorizontal: (0, scale_1.scale)(24),
        paddingVertical: (0, scale_1.scale)(5.5),
        justifyContent: 'center',
        alignItems: 'center',
    },
    unselectedLabel: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#D32F2F'
    },
    selectionBlank: {
        fontSize: (0, scale_1.moderateScale)(16),
        lineHeight: (0, scale_1.moderateScale)(24),
        color: '#292A33'
    },
    searchInput: {
        width: '100%',
        height: (0, scale_1.scale)(40),
        paddingHorizontal: (0, scale_1.scale)(10),
        marginTop: (0, scale_1.scale)(12),
        borderWidth: (0, scale_1.scale)(1),
        borderRadius: (0, scale_1.scale)(3),
        borderColor: '#C8C8C8',
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: '#FEFEFE',
    },
    textInput: {
        flex: 1,
        outlineWidth: 0,
        padding: 0,
        margin: 0,
        marginLeft: (0, scale_1.scale)(4),
        fontSize: (0, scale_1.moderateScale)(14),
        backgroundColor: 'white'
    },
    listUser: {
        flex: 1,
        marginTop: (0, scale_1.scale)(8),
    },
    userItem: {
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: (0, scale_1.scale)(8),
        paddingHorizontal: (0, scale_1.scale)(10),
        backgroundColor: '#EDEDED'
    },
    userAvatar: {
        width: (0, scale_1.scale)(42),
        height: (0, scale_1.scale)(42),
        borderRadius: 99,
    },
    userInfo: {
        flex: 1,
        height: '100%',
        marginLeft: (0, scale_1.scale)(12),
        justifyContent: 'space-between',
    },
    userNickname: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#292A33'
    },
    userHandle: {
        fontSize: (0, scale_1.moderateScale)(10),
        lineHeight: (0, scale_1.moderateScale)(17),
        color: '#888888'
    },
    loading: {
        backgroundColor: "transparent",
        paddingVertical: (0, scale_1.scale)(12),
    }
});
exports.default = ModalPickInheritUser;
